import React from 'react';
import * as styles from './PostViewStateBar.module.scss';

interface PostViewStateBarProps {
  children: React.ReactNode;
  actions?: React.ReactNode;
}

const PostViewStateBar = ({
  children,
  actions = null,
}: PostViewStateBarProps) => (
  <div className={styles.container}>
    <div className={styles.content}>{children}</div>
    {!!actions && <div className={styles.actions}>{actions}</div>}
  </div>
);

export default PostViewStateBar;
